import styled from "styled-components";
import {Link} from "react-router-dom";



export default function Footer(){

    return(
        <Wrapper>
            <section>
            © {new Date().getFullYear()} DaFa Rhein Sieg GmbH – Tiefbau & Glasfaser deutschlandweit
            </section>
            <Link className="link" to="/imprint">Impressum</Link>
        </Wrapper>
    )

}


const Wrapper = styled.footer`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 70px;
    gap: 20px;
    color: #344E97;
    background-color: #f9fafb;
    padding: 1rem;
    text-align: center;
    
    .link{
        color: #344E97;
    }
    
`;